import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function ContactUs() {
    const { t } = useTranslation();
    UseScrollAnimation();
    return (
        <>
            <section className="contact-landing">
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div className="">
                        <div className="btmAni2000 font-bold text-white text-[40px] capitalize">{t("Get Closer to Us")}</div>
                    </div>
                </div>
            </section>

            <section className="py-[40px]">
                <div className="container f-col flex justify-center gap-[20px]">
                    <div className="w-100 w-[31%] rounded-[4px] shadow-[0px_0px_10px_#00000030]">
                        <div className="w-full h-[250px]">
                            <img className="w-full h-full rounded-t-[4px]" src={require("../../assets/image/ksa.jpg")} alt="" />
                        </div>
                        <div className="p-[15px] flex flex-col justify-betweeen gap-[10px]">
                            <div className="font-bold text-[#0b2c3d] text-[20px]">{t("Location : KSA")}</div>
                            <div className="flex flex-col gap-[12px]">
                                <div className="flex items-center gap-[5px]">
                                    <span className="font-bold capitalize">{t("Phone Number")} : </span>
                                    <Link className="dir-ltr" to={"tel:+966 57 099 9395"}>
                                        +966 57 099 9395
                                    </Link>
                                </div>
                                <div className="flex items-center gap-[5px]">
                                    <span className="font-bold capitalize">{t("By Email")} : </span>
                                    <Link to={"mailto:info@ligasos.com"}>info@ligasos.com</Link>
                                </div>
                                <div className="flex flex-col gap-[5px]">
                                    <span className="font-bold capitalize">{t("working hours")}</span>
                                    <Link to={"https://www.google.com/search?q=ligasos&oq=ligasos&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQRRg8MgYIAhBFGDwyBggDEEUYPNIBBzU1OGowajeoAgCwAgA&sourceid=chrome&ie=UTF-8"} 
                                    className="flex flex-col">
                                        <span>{t("Sun to Thu 9am to 6pm")}</span>
                                        <span>{t("Friday and Saturday Closed")}</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-100 w-[31%] rounded-[4px] shadow-[0px_0px_10px_#00000030]">
                        <div className="w-full h-[250px]">
                            <img className="w-full h-full rounded-t-[4px]" src={require("../../assets/image/istanbul.jpg")} alt="" />
                        </div>
                        <div className="p-[15px] flex flex-col justify-betweeen gap-[10px]">
                            <div className="font-bold text-[#0b2c3d] text-[20px]">{t("Location : Türkiye")}</div>
                            <div className="flex flex-col gap-[12px]">
                                <div className="flex items-center gap-[5px]">
                                    <span className="font-bold capitalize">{t("Phone Number")} : </span>
                                    <Link className="dir-ltr" to={"tel:+90 544 141 00 90"}>
                                        +90 544 141 00 90
                                    </Link>
                                </div>
                                <div className="flex items-center gap-[5px]">
                                    <span className="font-bold capitalize">{t("By Email")} : </span>
                                    <Link to={"mailto:info@ligasos.com"}>info@ligasos.com</Link>
                                </div>
                                <div className="flex flex-col gap-[5px]">
                                    <span className="font-bold capitalize">{t("working hours")}</span>
                                    <Link to={"https://www.google.com/search?q=ligasos&oq=ligasos&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQRRg8MgYIAhBFGDwyBggDEEUYPNIBBzU1OGowajeoAgCwAgA&sourceid=chrome&ie=UTF-8"} 
                                    className="flex flex-col">
                                        <span>{t("Mon to Thu 9am to 6pm")}</span>
                                        <span>{t("Friday 9am to 1pm")}</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="py-[40px]">
                <div className="container flex flex-col gap-[20px]">
                    <div className="f-col flex justify-center">
                        <div className="js-scroll fade-top w-100 w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-md">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/phone.svg").default} alt="" />
                            </div>
                            <div className="flex flex-col items-center">
                                <span className="font-bold capitalize">{t("Phone Number")}</span>
                                <Link to={"tel:+966 57 099 9395"}>
                                    {t("KSA")} : +966 57 099 9395
                                </Link>
                                <Link to={"tel:+90 544 141 00 90"}>
                                    {t("TR")} : +90 544 141 00 90
                                </Link>
                            </div>
                        </div>
                        <div className="js-scroll fade-top w-100 w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-md">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/email.svg").default} alt="" />
                            </div>
                            <div className="flex flex-col items-center">
                                <span className="font-bold capitalize">{t("Email")}</span>
                                <Link to={"mailto:info@ligasos.com"}>info@ligasos.com</Link>
                            </div>
                        </div>
                        <div className="js-scroll fade-btm w-100 w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-md">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/work-hours.svg").default} alt="" />
                            </div>
                            <div className="flex flex-col items-center">
                                <span className="font-bold capitalize">{t("working hours")}</span>
                                <Link to={"https://www.google.com/search?q=ligasos&oq=ligasos&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQRRg8MgYIAhBFGDwyBggDEEUYPNIBBzU1OGowajeoAgCwAgA&sourceid=chrome&ie=UTF-8"} className="flex flex-col text-center items-center">
                                    <span>{t("Mon to Thu 9am to 6pm")}</span>
                                    <span>{t("Friday 9am to 1pm")}</span>
                                </Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section> */}

            <section className="relative py-[40px]">
                <div className="container">
                    <div className="w-100 flex mx-auto w-[75%] flex-col gap-[5px] items-center justify-center text-center">
                        <div className="js-scroll fade-top font-bold text-[25px] capitalize">{t("Get in Touch with Ligasos")}</div>
                        <p className="js-scroll fade-btm leading-[1.1]">
                            {t("Get in Touch with Ligasos Text")}
                        </p>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container">
                    <form action="https://ligasos.co/send_email.php" method="POST">
                        <div className="flex flex-col gap-[15px]">
                            <div className="f-col flex gap-[20px]">
                                <div className="w-100 w-[48%]">
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Full Name")}</label>
                                        <input className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]" name="fullName" type="text" placeholder={t("Full Name")} />
                                    </div>
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Email")}</label>
                                        <input className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]" name="email" type="email" placeholder={t("Email")} />
                                    </div>
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Phone Number")}</label>
                                        <input className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]" name="phone" type="number" placeholder={t("Phone Number")} />
                                    </div>
                                </div>
                                <div className="w-100 w-[48%] flex flex-col gap-[7px]">
                                    <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Massage")}</label>
                                    <textarea name="message" className="h-250 h-full max-h-[350px] js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]" placeholder={t("Massage")}></textarea>
                                </div>
                            </div>
                            <button type="submit" className="js-scroll fade-btm w-fit bg-[#132A40] text-white px-[40px] py-[8px] rounded font-bold capitalize">{t("send")}</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
}